var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{ref:"guest-list",attrs:{"id":"guest-list","size":"modal-md","show":_vm.show,"show-close-button":true},on:{"closed":_vm.modalClosed}},[_c('div',[_vm._v("\n    "+_vm._s(_vm.modalType)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }